import { Box, IconButton, Stack } from '@atgfr8/atg-ui-tailwind';
import { CommentViewModel } from '@store/orders';
import { userStore } from '@store/user';
import { DeleteIcon } from '@atgfr8/icons';
import { convertUtcToLocalAndFormat } from '@utils/dateFormat';
import { isAdmin } from '@utils/utils';

type PropsT = {
  comment: CommentViewModel;
  onDelete: () => void;
  showNewLines?: boolean; //unsure if all usages should have newLines, so making this optional for now
};

export const LoadComment = (props: PropsT) => {
  return (
    <Box>
      <Box padding="5px" backgroundColor="#f3f3f3">
        <Stack direction="row" justifyContent="space-between">
          <Box class="font-bold">{props.comment.name}</Box>
          <Box>
            <span>
              {convertUtcToLocalAndFormat(
                props.comment.timestamp as unknown as string,
                'MMMM dd, yyyy h:mm a',
              )}
            </span>
            {props.comment.userId === userStore.user.id || isAdmin() ? (
              <IconButton
                size="sm"
                onClick={props.onDelete}
                dataTestId={`load-comment-delete-${props.comment.id}`}
              >
                <DeleteIcon size={20} color="#d32f2f" />
              </IconButton>
            ) : undefined}
          </Box>
        </Stack>
      </Box>
      {props.showNewLines ? (
        <Box padding="5px" style={{ 'white-space': 'pre-line' }}>
          {props.comment.comment}
        </Box>
      ) : (
        <Box padding="5px">{props.comment.comment}</Box>
      )}
    </Box>
  );
};
